import { createFileRoute } from "@tanstack/react-router";
import { BankingAdmin } from "@/components/Banking/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const bankId = params?.id as string;

  return <BankingAdmin bankAccountId={bankId} />;
}

export const Route = createFileRoute("/_authenticated/banking/$id/")({
  component: RouteComponent,
  staticData: { page: ["banking", "deals"] },
});
